import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../compnents/common/Loading";
import { useCheckAuth } from "../../hooks/auth";
import { getOnboardedOrganisation } from "../../store/api/organisation";

const DeepLinkHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { companyName } = useParams();
  const [isProcessing, setIsProcessing] = useState(true);
  const { refetch, isAuthenticated } = useCheckAuth();
  console.log("deeplink here");
  // Query to check onboarding status
  const { data: orgData, refetch: refetchOrgData } = useQuery({
    queryKey: ["onboardedOrganisation", { context: "deeplink" }],
    queryFn: () => getOnboardedOrganisation({}),
    enabled: false, // We'll manually trigger this after auth check
  });

  useEffect(() => {
    const handleDeepLink = async () => {
      try {
        const token = localStorage.getItem("token");
        const storedCompanyName = localStorage.getItem("companyName");
        const currentPath = location.pathname;
        const fullPath = currentPath + location.search;

        console.log("DeepLinkHandler - Current path:", currentPath);
        console.log("DeepLinkHandler - Company from URL:", companyName);
        console.log(
          "DeepLinkHandler - Company from storage:",
          storedCompanyName
        );

        // Update company name in localStorage if different
        if (companyName && companyName !== storedCompanyName) {
          localStorage.setItem("companyName", companyName);
          console.log("Updated companyName in localStorage:", companyName);
        }

        // If no token, redirect to login
        if (!token) {
          console.log("No token found, redirecting to login");
          localStorage.setItem("pendingDeepLink", fullPath);
          localStorage.setItem("pendingCompany", companyName);
          navigate(`/${companyName}/login`, { replace: true });
          return;
        }

        console.log("Checking authentication...");

        if (!isAuthenticated) {
          console.log("Authentication failed, redirecting to login");
          localStorage.setItem("pendingDeepLink", fullPath);
          localStorage.setItem("pendingCompany", companyName || "");
          navigate(`/${companyName}/login`, { replace: true });
          return;
        }

        console.log("User authenticated, checking onboarding status...");

        // Check onboarding status
        // const orgResult = await refetchOrgData();
        // const isOnBoarded = orgResult.data?.isOnBoarded;
        const isOnBoarded = JSON.parse(localStorage.getItem("isOnBoarded"));

        console.log("Onboarding status:", isOnBoarded);

        // Redirect based on onboarding status
        if (isOnBoarded === false) {
          console.log("User not onboarded, redirecting to onboarding");
          navigate(`/${companyName}/onboarding`, { replace: true });
        } else {
          console.log("User onboarded, checking for intended destination");

          // Check if user was trying to access a specific path
          if (currentPath === `/${companyName}`) {
            // If they accessed the company root, go to dashboard
            console.log("Redirecting to dashboard (company root access)");
            navigate(`/${companyName}/dashboard`, { replace: true });
          } else {
            // If they were trying to access a specific path, redirect there
            console.log("Redirecting to original path:", fullPath);
            navigate(fullPath, { replace: true });
          }
        }
      } catch (error) {
        console.error("Error handling deep link:", error);

        // Store the pending deep link for after login
        localStorage.setItem(
          "pendingDeepLink",
          location.pathname + location.search
        );
        localStorage.setItem("pendingCompany", companyName || "");

        // Redirect to login
        navigate(`/${companyName}/login`, { replace: true });
      } finally {
        setIsProcessing(false);
      }
    };

    handleDeepLink();
  }, [location, navigate, companyName, refetch, refetchOrgData]);

  if (isProcessing) {
    return <Loading />;
  }

  return null;
};

export default DeepLinkHandler;
